//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import role from "apis/role/role";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);

  const { createRole, screenviewdetail } = role();
  const history = useHistory();
  const classes = styles();
  const [states, setstates] = useState({
    roleId: "",
    roleName: "",
    onewebRoleId: null,
    onewebAuthorizedRoleId: false,
    isActive: true,
    loading: false,
    screens: [],
    edittedData: {}
  });

  const {
    roleId,
    roleName,
    onewebRoleId,
    onewebAuthorizedRoleId,
    isActive,
    loading,
    screens,
    edittedData
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "ROLE", "CREATE"],
    });
  }, []);

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = async () => {
    try {
      let values = { id: null }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await screenviewdetail(values);
      if (res) {
        setStates({ screens: res?.data });
        // setDataClone(res?.data[0]);
        // setCount(res?.count);
        // setBalance(res?.currentBalance)
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // create api func
  const handleCreateRole = async () => {
    try {
      if (
        !roleName
      ) {
        toast.error("Please fill all the fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }

      let values;
      values = {
        roleName,
        isActive,
        screens: edittedData?.screenEdited?.filter(i => i.screen_is_active == true).map(j => j.screen_name)
      };

      let res = await createRole(values);
      if (res && res?.type === "SUCCESS") {
        toast.success("Created", { toastId: "rule-created" });
        history.goBack();
      }
      if (res && res?.type === "ERROR") {
        toast.error("Role Already Exists", {
          toastId: "role-exists",
        });
      }
      setStates({ loading: false });
    }
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>{'Create'}</span>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={4}>
          <CssTextField
            label={"Role Name"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={roleName}
            onChange={(e) => {
              setStates({ roleName: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <CssTextField
            id={"Is Active"}
            label={"Is Active"}
            select
            fullWidth
            type={"text"}
            required
            value={isActive}
            onChange={(e) => {
              setStates({ isActive: e.target.value });
            }}
          >
            {[
              { label: "True", value: true },
              { label: "False", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
        <Grid xs={4}></Grid>
        <Grid xs={4}></Grid>
        <Grid xs={4}></Grid>
        <Grid xs={12}><strong>Screens:</strong></Grid>
        {/* <Grid item xs={12}> */}
          {/* <FormGroup>{
            screens?.map(i => {
              return <FormControlLabel
                key={i.screen_id}
                control={
                  <Checkbox
                    color="primary"
                    checked={i.screen_is_active}
                    onChange={(e) => {
                      let arr = [...states?.screens];
                      let index = arr.findIndex(k => k.screen_id == i.screen_id);
                      console.log(i.screen_id, e.target.checked, 'e.target.checked')
                      if (e.target.checked) {
                        arr[index].screen_is_active = true
                      } else {
                        arr[index].screen_is_active = false
                      }
                      setStates({
                        ...states, screens: arr, edittedData: {
                          screenEdited: arr,
                        },
                      })
                    }}
                  />
                }
                label={i.screen_name}
              // disabled={!isEdit}
              />
            })}
          </FormGroup> */}
          {Array.from({ length: 4 }).map((_, columnIndex) => (
            <Grid item xs={3} key={columnIndex} sx={{ flexGrow: 1 }} className={classes.griditem}>
              {screens?.slice(columnIndex * Math.ceil(screens.length / 4), (columnIndex + 1) * Math.ceil(screens.length / 4))
                .map((i) => (
                  <FormControlLabel
                    key={i.screen_id}
                    control={
                      <Checkbox
                        color="primary"
                        checked={i.screen_is_active}
                        onChange={(e) => {
                          let arr = [...states?.screens];
                          let index = arr.findIndex(k => k.screen_id == i.screen_id);
                        
                          if (e.target.checked) {
                            arr[index].screen_is_active = true
                          } else {
                            arr[index].screen_is_active = false
                          }
                          setStates({
                            ...states, screens: arr, edittedData: {
                              screenEdited: arr,
                            },
                          })
                        }}
                      />
                    }
                    label={i.screen_name}
                    className={classes.formControlLabel}
                  // disabled={!isEdit}
                  />
                ))}
            </Grid>
          ))}
        </Grid>
      {/* </Grid> */}
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            className={classes.submitBtn}
            onClick={() => {
              if(roleName && roleName?.length>38){
                toast.error("Role name is too long; please limit to 40 alphabets.", {
                  toastId: "role-exists",
                });

                return;

              }
              setStates({ loading: true });
              handleCreateRole();
            }}
            disabled={loading}
          >
            {'Submit'}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
